import { styled } from '@linaria/react';
import { NoStyleButton } from '@vio/atlas/helpers/NoStyleButton';
export const ExperimentId = /*#__PURE__*/styled('div')({
  name: "ExperimentId",
  class: "e1h9s2pj",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => NoStyleButton;
export const ActionIconWrapper = /*#__PURE__*/styled(_exp())({
  name: "ActionIconWrapper",
  class: "a5xpbpv",
  propsAsIs: true
});
export const RowWrapper = /*#__PURE__*/styled('div')({
  name: "RowWrapper",
  class: "r1edbxgo",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  variant
}) => variant == 'forced' ? '#d4d4d4' : '#fbfbfb';
export const ExperimentWrapper = /*#__PURE__*/styled('div')({
  name: "ExperimentWrapper",
  class: "ea2nicx",
  propsAsIs: false,
  vars: {
    "ea2nicx-0": [_exp2()]
  }
});
export const statusColorMap = {
  a: '#82b74b',
  b: '#c94c4c',
  auto: '#888'
};
export type StatusColorMapType = keyof typeof statusColorMap;
const _exp3 = /*#__PURE__*/() => ({
  status
}) => ({
  a: "#82b74b",
  b: "#c94c4c",
  auto: "#888"
})[status];
export const StatusBadge = /*#__PURE__*/styled('span')({
  name: "StatusBadge",
  class: "s1oorzru",
  propsAsIs: false,
  vars: {
    "s1oorzru-0": [_exp3()]
  }
});
export const InputRowWrapper = /*#__PURE__*/styled('div')({
  name: "InputRowWrapper",
  class: "i2cg5nj",
  propsAsIs: false
});
export const InputWrapper = /*#__PURE__*/styled('div')({
  name: "InputWrapper",
  class: "i13mxtc4",
  propsAsIs: false
});

require("./styled.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styled.tsx");